export const shortTestimonials = [
  {
    initials: 'AT',
    name: 'Alejandra T.',
    place: 'Buenos Aires',
    quote: 'Por fin entiendo qué significan esos términos que me asustaban. Me siento mucho menos perdida.'
  },
  {
    initials: 'RS',
    name: 'Roxana S.',
    place: 'Córdoba',
    quote: 'Aprendí a separar lo que realmente importa de todo lo que me genera pánico en Internet. Ahora puedo preguntar con seguridad.'
  },
  {
    initials: 'DL',
    name: 'Daniela L.',
    place: 'Rosario',
    quote: 'No intento resolver sola cosas que no me corresponden. Tengo un método claro para ordenar mis dudas y conversar mejor.'
  },
  {
    initials: 'MJ',
    name: 'Mónica J.',
    place: 'Mendoza',
    quote: 'Es como si me dieran una herramienta para ver claro en toda la confusión. Ahora sé exactamente qué hacer con cada información.'
  }
] as const;

export const extendedTestimonials = [
  {
    name: 'Lucía M.',
    place: 'Buenos Aires',
    quote: '“Finalmente tengo claridad sobre qué puedo controlar y qué no. Me liberó de tanta presión mental.”'
  },
  {
    name: 'Verónica R.',
    place: 'Córdoba',
    quote: '“Aprendí a comunicar mis dudas de forma que el médico realmente entienda qué necesito saber.”'
  },
  {
    name: 'Gabriela P.',
    place: 'Rosario',
    quote: '“La guía me enseñó a ordenar información sin intentar jugar a médica. Fue un alivio enorme.”'
  },
  {
    name: 'Carolina N.',
    place: 'Mendoza',
    quote: '“Cambió cómo veo la información. Ahora tengo un método, no solo pánico.”'
  }
] as const;

export const purchases = [
  ['Alejandra T.', 'Buenos Aires'],
  ['Roxana S.', 'Córdoba'],
  ['Daniela L.', 'Rosario'],
  ['Mónica J.', 'Mendoza']
] as const;
